export default "__VITE_ASSET__CHd61Av7__"